import { OverlayRef } from '@angular/cdk/overlay';
import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MegaMenuOverlayRef {
  overlayRef!: OverlayRef;
  activeElementRef!: ElementRef;
  currentElementRef!: ElementRef;

  constructor() {}
}
